export default function VPNProduct() {
  return (
    <section id="vpn" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
          <div className="grid md:grid-cols-2 gap-12 items-center p-12">
            <div className="relative">
              <div className="relative z-10">
                <img
                  src="https://public.readdy.ai/ai/img_res/d7264acbf3e6df772e2db970f6976987.jpg"
                  alt="HORAL VPN Application Interface"
                  className="w-full h-auto rounded-2xl shadow-2xl"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 w-64 h-64 bg-gradient-to-br from-teal-400/20 to-purple-400/20 rounded-full blur-3xl"></div>
            </div>

            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
                HORAL VPN
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                Our premium VPN solution provides you with complete online privacy and security. Connect to servers worldwide and enjoy unrestricted internet access.
              </p>

              <div className="space-y-4">
                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 flex items-center justify-center mt-1">
                    <i className="ri-shield-check-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 text-lg">Military-Grade Encryption</h3>
                    <p className="text-gray-600">AES-256 encryption keeps your data completely secure</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 flex items-center justify-center mt-1">
                    <i className="ri-eye-off-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 text-lg">Strict No-Logs Policy</h3>
                    <p className="text-gray-600">We never track, collect, or share your private data</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 flex items-center justify-center mt-1">
                    <i className="ri-global-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 text-lg">Global Server Network</h3>
                    <p className="text-gray-600">Access servers in multiple countries worldwide</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 flex items-center justify-center mt-1">
                    <i className="ri-flashlight-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 text-lg">Lightning-Fast Speeds</h3>
                    <p className="text-gray-600">Optimized servers for seamless streaming and browsing</p>
                  </div>
                </div>
              </div>

              <button className="mt-6 border-2 border-teal-600 text-teal-600 px-8 py-3 rounded-full font-semibold hover:bg-teal-600 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer">
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
